import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import './Select.css';

class Select extends Component {
  handleSelect(e) {
    const { onChange, name } = this.props;
    onChange(name, e.target.value);
  }

  renderOptions() {
    const { options } = this.props;
    return options.map((option) => {
      const { id: optionId, value: optionValue, ...optionRest } = option;

      return (
        <option
          value={optionId}
          test={optionValue}
          key={optionId}
          {...optionRest}
        >
          {optionValue}
        </option>
      );
    });
  }

  render() {
    const {
      test,
      className,
      value,
      tabIndex,
      disabled,
      onMouseEnter,
      onMouseLeave,
    } = this.props;
    return (
      <select
        test={test}
        className={`select ${className}`}
        value={value === null ? '' : value}
        onChange={e => this.handleSelect(e)}
        tabIndex={tabIndex}
        disabled={disabled}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {this.renderOptions()}
      </select>
    );
  }
}

Select.propTypes = {
  options: PropTypes.array.isRequired,
  test: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  name: PropTypes.string,
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  disabled: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};

Select.defaultProps = {
  test: null,
  value: null,
  name: '',
  className: '',
  tabIndex: '0',
  onChange: noop,
  disabled: false,
  onMouseEnter: () => ({}),
  onMouseLeave: () => ({}),
};

export default Select;
